// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.viewTicket_dashboard__aNZYx {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.viewTicket_dashboardContain__yW1oK {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_dashboardContain__yW1oK,
.viewTicket_bodythemedark__wCIg- .viewTicket_dashboard__aNZYx,
.viewTicket_bodythemedark__wCIg- .viewTicket_cont2__2Jbki {
  background-Color: #0f1824;
}

.viewTicket_top_header__ws95f .viewTicket_top_header_inner__YMlQN {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.viewTicket_cont2__2Jbki {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.viewTicket_subLink__RT-x4 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.viewTicket_cst_vendr__JnvXV input {
  min-height: 35px !important;
}

.viewTicket_cst_vendr__JnvXV .viewTicket_form-control__LEtJC {
  background-color: #f5f6fa;
  border: none;
}

.viewTicket_footer__\\+\\+L1x {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.viewTicket_bodythemelight__od1Pk {
  background-color: #fff;
  padding-top: 90px;
}

.viewTicket_bodythemedark__wCIg- {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.viewTicket_headerthemelight__SAQLg {
  background-color: #fff;
}

.viewTicket_headerthemedark__H6h5V {
  background-color: #132337;
}

.viewTicket_top_header__ws95f {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.viewTicket_menuthemelight__X7JCP {
  background-color: #fff;
}

.viewTicket_menuthemedark__V\\+GGf {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.viewTicket_menulinklight__yd0cJ span {
  color: #666666 !important;
}

.viewTicket_menulinklight__yd0cJ a {
  color: #CBCBCB !important;
}

.viewTicket_menulinklight__yd0cJ:hover span,
.viewTicket_menulinklight__yd0cJ:hover a {
  color: #fff !important;
}

.viewTicket_menulinkdarkSelected__eSADz {
  background-color: #1c2e45;
  color: #3b82f6;
}

.viewTicket_menuthemelight__X7JCP .viewTicket_menulinklightSelected__4VQa6 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewTicket_menulinkdark__\\+LNZg {
  color: #92afd3 !important;
}

.viewTicket_menulinklight__yd0cJ:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.viewTicket_menulinklight__yd0cJ .viewTicket_sub_arrow__8GScY svg path {
  stroke: #CBCBCB !important;
}

.viewTicket_menulinklight__yd0cJ:hover .viewTicket_sub_arrow__8GScY svg path {
  stroke: #fff !important;
}

.viewTicket_menulinkdark__\\+LNZg .viewTicket_sub_arrow__8GScY svg path {
  stroke: #92afd3 !important;
}

.viewTicket_menulinkdark__\\+LNZg:hover .viewTicket_sub_arrow__8GScY svg path {
  stroke: #fff !important;
}

.viewTicket_menulinklight__yd0cJ:hover svg path,
.viewTicket_menulinklightSelected__4VQa6 svg path {
  fill: #fff !important;
}

.viewTicket_menulinkdark__\\+LNZg:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.viewTicket_headinglight__34zIa {
  color: #60677e;
}

.viewTicket_headingdark__AZLsQ {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.viewTicket_searchboxlight__ecjOU {
  background-color: #fff;
  border: none;
}

.viewTicket_searchboxdark__ah1oz {
  background-color: #132337;
  color: #fff;
  border: none;
}

.viewTicket_searchboxdark__ah1oz::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.viewTicket_tableheadlight__CCjgR {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.viewTicket_tableheadlight__CCjgR th {
  color: #fff;
}

thead .viewTicket_tableheadlight__CCjgR th:first-child,
thead .viewTicket_tableheaddark__HGPum th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .viewTicket_tableheadlight__CCjgR th:last-child,
thead .viewTicket_tableheaddark__HGPum th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.viewTicket_table__5QzYT.viewTicket_table-borderless__UwRrM {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.viewTicket_tableheaddark__HGPum {
  background-color: #132337;
  color: #fff;
}

.viewTicket_table-borderless__UwRrM tr:nth-child(even) {
  background-color: #F9FAFB;
}

.viewTicket_table-borderless__UwRrM .viewTicket_left-section__IGUPk {
  padding-top: 10px;
}

.viewTicket_tablebodylight__51UYI td,
.viewTicket_tablebodydark__-YlqC td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.viewTicket_tablebodylight__51UYI {
  background-color: #fff;
}
.viewTicket_tablebodylight__51UYI:hover {
  background-color: #fff;
  cursor: auto;
}

.viewTicket_tablebodydark__-YlqC {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.viewTicket_tablebodydark__-YlqC:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.viewTicket_paginationlight__HPZqd {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewTicket_paginationdark__OwMcr {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.viewTicket_formthemelight__wG-Rw {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewTicket_formthemedark__gj5iY {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.viewTicket_formthemedark__gj5iY ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewTicket_viewformlight__Ho4P4 {
  background-color: #f3f6f9;
}

.viewTicket_permissionboxlight__z6w1h {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewTicket_permissionboxdark__SxYZd {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.viewTicket_errormsgclr__XW8zC {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.viewTicket_graphclrlight__uYIfz {
  background-color: #fff;
}

.viewTicket_graphclrdark__yxJ-S {
  background-color: #132337;
}

/* 
Counter theme
*/
#viewTicket_card1bglight__BO-A3 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#viewTicket_card1bgdark__1dqP3 {
  background: #392f28;
}

#viewTicket_card2bglight__eGKtx {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#viewTicket_card2bgdark__EPPlH {
  background: #1c3238;
}

#viewTicket_card3bglight__EOZDZ {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#viewTicket_card3bgdark__Ja6gy {
  background: #3a2434;
}

#viewTicket_card4bglight__QYRg6 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#viewTicket_card4bgdark__PSkAj {
  background: #2f264f;
}

#viewTicket_card1bgdark__1dqP3 a,
#viewTicket_card1bgdark__1dqP3 p,
#viewTicket_card2bgdark__EPPlH a,
#viewTicket_card2bgdark__EPPlH p,
#viewTicket_card3bgdark__Ja6gy a,
#viewTicket_card3bgdark__Ja6gy p,
#viewTicket_card4bgdark__PSkAj a,
#viewTicket_card4bgdark__PSkAj p {
  color: #fff;
}

/* 
Action button theme
*/
.viewTicket_actionbtnlight__P9Hky {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewTicket_actionbtndark__--6OQ {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.viewTicket_profiledropdownlight__NH-Fu {
  background-color: #fff;
}

.viewTicket_profiledropdowndark__YGP00 {
  background-color: #151521;
}

.viewTicket_settingsection__Gzgmn #viewTicket_addform__7eDjY.viewTicket_formthemedark__gj5iY .viewTicket_savebtn__Ypy0O {
  background-color: #3b82f6;
  color: #fff;
}

#viewTicket_addform__7eDjY.viewTicket_formthemedark__gj5iY .viewTicket_savebtn__Ypy0O {
  background-color: #3b82f6;
  color: #fff;
}

.viewTicket_profile_conatiner__3WtDM {
  border-radius: 5px !important;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_ag-theme-alpine__dIuO3 .viewTicket_ag-row__kEuDw {
  background: #000 !important;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_formbtn__MSRUq {
  background-color: #3b82f6;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_formbtn__MSRUq:hover {
  background-color: #2563eb;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_resetbtn__kNbK7 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.viewTicket_headingdark__AZLsQ span {
  background-color: #132337;
}

.viewTicket_resetbtn__kNbK7 {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.viewTicket_resetbtn__kNbK7:hover,
.viewTicket_resetbtn__kNbK7:active,
.viewTicket_resetbtn__kNbK7:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.viewTicket_addBtn__ToIWh {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewTicket_addDltBtn__zG4Nu {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewTicket_addbtnlight__YwzpA {
  background-color: #38A169;
}

.viewTicket_addbtndark__gU6YW {
  background-color: #3b82f6;
}

.viewTicket_addbtndark__gU6YW:hover {
  background-color: #2563eb;
}

.viewTicket_formthemedark__gj5iY label {
  color: #92afd3;
}

.viewTicket_addBtn__ToIWh svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.viewTicket_addBtn__ToIWh:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.viewTicket_cust_addBtn__j8iRX.viewTicket_addBtn__ToIWh svg {
  top: 2px;
}

.viewTicket_deleteBtn__YvlSa {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewTicket_deleteBtn__YvlSa:active,
.viewTicket_deleteBtn__YvlSa:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewTicket_deleteBtn__YvlSa svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewTicket_deleteBtn__YvlSa:hover,
.viewTicket_deleteBtn__YvlSa:active,
.viewTicket_deleteBtn__YvlSa:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.viewTicket_confirmBtn__DbuOk {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.viewTicket_confirmBtn__DbuOk:active,
.viewTicket_confirmBtn__DbuOk:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewTicket_confirmBtn__DbuOk:hover,
.viewTicket_confirmBtn__DbuOk:active,
.viewTicket_confirmBtn__DbuOk:focus {
  background-color: #0f1824 !important;
}

.viewTicket_confirmBtn__DbuOk svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.viewTicket_delPopContainer__4uHNt .viewTicket_modal-body__SfY4l {
  padding: 35px;
  text-align: center;
}

.viewTicket_delPopContainer__4uHNt .viewTicket_delet_icon__ghEWv {
  margin-bottom: 11px;
}

.viewTicket_delPopContainer__4uHNt p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.viewTicket_arrowback__NJet5 svg {
  fill: #000;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_arrowback__NJet5 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_arrowback__NJet5 svg {
  fill: #3b82f6;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_drpdwn_btn__g-Uz1 {
  background-color: #132337;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_empname__tlX3M {
  color: #92afd3 !important;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_navitemli__EHaWT a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_tabnavli__Or8x4 a.viewTicket_settingsgeneral__XLmfK,
.viewTicket_bodythemedark__wCIg- .viewTicket_tabnavli__Or8x4 a.viewTicket_settingslinks__m6xFw:hover {
  background-color: #3b82f6;
  color: #fff;
}

.viewTicket_bodythemedark__wCIg- .viewTicket_tabnavli__Or8x4 a.viewTicket_settingslinks__m6xFw {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 {
  background-color: #1c2e45;
  color: #fff;
}

.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 ul li a,
.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 .viewTicket_dropdown_item__Lv-Nx,
.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 .viewTicket_dropdown_item__Lv-Nx h5 {
  color: #fff;
}

.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 ul li a:hover,
.viewTicket_headerthemedark__H6h5V .viewTicket_dropdown_menu_contain__g3iQ1 .viewTicket_dropdown_item__Lv-Nx:hover {
  background-color: #132337;
  color: #fff;
}

.viewTicket_dropdown_item__Lv-Nx:active {
  background-color: #F5F6FA;
}

.viewTicket_profile_arrrow_dwn__vFacI {
  stroke: #132337;
}

.viewTicket_headerthemedark__H6h5V .viewTicket_profile_arrrow_dwn__vFacI {
  stroke: #fff;
}

.viewTicket_dateinputbox1__SuLx- input,
.viewTicket_dateinputbox1__SuLx- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.viewTicket_delPopContainer__4uHNt .viewTicket_modal-content__uINlq {
  border-radius: 10px;
  min-width: 399px;
}

.viewTicket_larg_model__hCwH7 .viewTicket_modal-dialog__oRQIJ {
  max-width: 100% !important;
}

.viewTicket_larg_model__hCwH7 .viewTicket_modal-content__uINlq {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.viewTicket_larg_model__hCwH7 .viewTicket_modal-header__EGbzH {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .viewTicket_btn-primary__5Mfef:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.viewTicket_form-select__5SA\\+y {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .viewTicket_CustomTable_tableheadlight__HuHZw__AZF\\+- th:first-child,
thead .viewTicket_CustomTable_tableheaddark__nwqb4__Bab9Q th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .viewTicket_tableheadlight__CCjgR th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .viewTicket_dashboard__aNZYx {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .viewTicket_cont2__2Jbki {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .viewTicket_sectionright__De7mJ {
    float: unset !important;
  }
  .viewTicket_formthemelight__wG-Rw {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .viewTicket_dashboard__aNZYx {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .viewTicket_cont2__2Jbki {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .viewTicket_bodythemelight__od1Pk,
.viewTicket_bodythemedark__wCIg- {
    padding-top: 110px;
  }
  .viewTicket_delPopContainer__4uHNt .viewTicket_modal-content__uINlq {
    min-width: 100%;
  }
  .viewTicket_delPopContainer__4uHNt .viewTicket_modal-body__SfY4l {
    padding: 15px;
  }
  .viewTicket_larg_model__hCwH7 .viewTicket_modal-content__uINlq {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .viewTicket_exer_modal_contain__d9rqY .viewTicket_modal-dialog__oRQIJ {
    max-width: 1055px;
  }
  .viewTicket_delPopContainer__4uHNt .viewTicket_modal-dialog__oRQIJ {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.viewTicket_active_show_outer__Oi6fk h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 {
  width: 100%;
  display: block;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_img__BFoa7 {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_img__BFoa7 {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_img__BFoa7 img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 {
  width: 100%;
  display: block;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 svg {
  flex-shrink: 0;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 .viewTicket_act_box_bdg__wJGic {
  width: 100%;
  margin-bottom: 12px;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 .viewTicket_act_box_bdg__wJGic span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 .viewTicket_act_box_bdg__wJGic .viewTicket_sold__Fnz7n {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.viewTicket_active_show_outer__Oi6fk .viewTicket_active_show_inner__q5Wv2 .viewTicket_act_box_cnt__uZAS8 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_l__-REFj img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_l__-REFj img {
    object-fit: contain;
    width: auto;
  }
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz {
  flex: 1 1;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT .viewTicket_attent_details_row_box__Iu6-l {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT .viewTicket_attent_details_row_box__Iu6-l {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT .viewTicket_attent_details_row_box__Iu6-l {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT .viewTicket_attent_details_row_box__Iu6-l p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row__jsCrT .viewTicket_attent_details_row_box__Iu6-l h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row_last__krk96 {
  margin-bottom: 0px !important;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row_last__krk96.viewTicket_interesting_fact__VbzRg {
  padding-top: 30px;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row_last__krk96.viewTicket_interesting_fact__VbzRg .viewTicket_attent_details_row_box__Iu6-l {
  width: 100%;
}
.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ .viewTicket_attent_details_inner_r__sZWfz .viewTicket_attent_details_row_last__krk96.viewTicket_interesting_fact__VbzRg .viewTicket_attent_details_row_box__Iu6-l h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.viewTicket_showbox_sec__5nRCW {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .viewTicket_showbox_sec__5nRCW {
    grid-template-columns: 1fr;
  }
}

.viewTicket_show_box_main__jd51W {
  margin: 10px 0px;
  width: 100%;
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK {
    min-height: 500px;
  }
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK .viewTicket_active_show_inner__q5Wv2 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK .viewTicket_act_box_img__BFoa7 {
  flex-shrink: 0;
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK .viewTicket_act_box_cnt__uZAS8 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK img {
    max-height: 300px !important;
  }
}
.viewTicket_show_box_main__jd51W .viewTicket_show_box__nQUUK:last-child {
  margin-right: 0;
}
.viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg {
    width: 250px !important;
  }
}
.viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg img {
    max-height: 350px !important;
  }
}
.viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .viewTicket_show_box_main__jd51W .viewTicket_no_show_box__jfQOg h6 {
    font-size: 20px;
  }
}

.viewTicket_attent_flex__p0fTT {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.viewTicket_attent_flex__p0fTT h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

/* ── Ticket Details Page Layout ─────────────────────────────────── */
.viewTicket_pageWrapper__0y7NX {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 4px;
}

.viewTicket_pageLayout__S7\\+IY {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 20px;
  align-items: start;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.viewTicket_mainPanel__3IR3K,
.viewTicket_sidebarPanel__ReZbf {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.viewTicket_statusCard__WRzmJ {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.viewTicket_statusLeft__3n-ES {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 0 0 auto;
}

.viewTicket_statusRight__q9Iwu {
  text-align: right;
  flex-shrink: 0;
}

.viewTicket_priceAmount__TA\\+Ha {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
}

.viewTicket_infoGrid__6u5M2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 32px;
}

.viewTicket_loadingWrap__B79vS {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  width: 100%;
}

/* Tablet */
@media only screen and (max-width: 1024px) {
  .viewTicket_pageLayout__S7\\+IY {
    grid-template-columns: 1fr 240px;
    gap: 16px;
  }
}
/* Small tablet / large mobile */
@media only screen and (max-width: 768px) {
  .viewTicket_pageWrapper__0y7NX {
    padding: 0;
    overflow-x: hidden;
    max-width: 100%;
  }
  .viewTicket_pageLayout__S7\\+IY {
    grid-template-columns: 1fr !important;
    gap: 0;
    overflow: hidden;
  }
  .viewTicket_mainPanel__3IR3K {
    order: 1;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
  .viewTicket_sidebarPanel__ReZbf {
    order: 2;
    min-width: 0;
    max-width: 100%;
    margin-top: 16px;
    overflow: hidden;
  }
  .viewTicket_infoGrid__6u5M2 {
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;
  }
  .viewTicket_statusCard__WRzmJ {
    padding: 14px 16px;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .viewTicket_statusLeft__3n-ES {
    flex: 1 1 auto;
    min-width: 0;
  }
  .viewTicket_statusRight__q9Iwu {
    text-align: right;
    flex: 0 0 auto;
  }
  .viewTicket_priceAmount__TA\\+Ha {
    font-size: 20px;
  }
}
/* Mobile */
@media only screen and (max-width: 576px) {
  .viewTicket_infoGrid__6u5M2 {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .viewTicket_priceAmount__TA\\+Ha {
    font-size: 18px;
  }
}
/* Small mobile */
@media only screen and (max-width: 400px) {
  .viewTicket_statusCard__WRzmJ {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
  }
  .viewTicket_statusRight__q9Iwu {
    text-align: left;
    width: 100%;
  }
  .viewTicket_priceAmount__TA\\+Ha {
    font-size: 22px;
  }
}
/* ── existing styles below ── */
#viewTicket_addform__7eDjY {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 20px;
}
#viewTicket_addform__7eDjY #viewTicket_addheading__j8PRp {
  font-size: 18px;
  margin-left: 10px;
}
#viewTicket_addform__7eDjY .viewTicket_profilepicdiv__shdys {
  padding: 0px;
  border-radius: 5px;
  text-align: center;
}
#viewTicket_addform__7eDjY .viewTicket_profilepic__0JGHL {
  width: 100%;
  border-radius: 5px;
}
#viewTicket_addform__7eDjY .viewTicket_namesection__-msR3 {
  display: inline-block;
}
#viewTicket_addform__7eDjY .viewTicket_profilename__XymQp {
  font-size: 16px;
  margin-left: 20px;
  margin-top: 30px;
}
#viewTicket_addform__7eDjY .viewTicket_profileemail__QjRnA {
  font-size: 14px;
  margin-left: 20px;
}
#viewTicket_addform__7eDjY #viewTicket_empdiv__pCYvk {
  padding: 0px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: transparent;
}
#viewTicket_addform__7eDjY #viewTicket_empdiv__pCYvk .viewTicket_title__fHmC9 {
  font-size: 13px;
}
#viewTicket_addform__7eDjY #viewTicket_empdiv__pCYvk .viewTicket_empname__tlX3M {
  font-size: 16px;
  color: #131F43;
  font-weight: 600;
  margin-bottom: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
}
#viewTicket_addform__7eDjY .viewTicket_arrowback__NJet5 {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #39979d;
  cursor: pointer;
  border-radius: 3px;
}
#viewTicket_addform__7eDjY .viewTicket_arrowback__NJet5:hover {
  background-color: #39979d;
  color: #fff;
}

.viewTicket_profile_view_container__Fqdno {
  padding: 30px;
}
@media screen and (max-width: 768px) {
  .viewTicket_profile_view_container__Fqdno {
    padding: 15px;
  }
}

.viewTicket_profile_view_container__Fqdno span {
  font-size: 13px;
  margin-bottom: 7px;
}

.viewTicket_formthemedark__gj5iY.viewTicket_profile_view_container__Fqdno span {
  color: #fff;
}

.viewTicket_edit_b_sc__l0gkN .viewTicket_formbtnedit__PSiYh {
  padding: 0 17px 0 28px !important;
  background-color: #ff9330 !important;
  min-width: 110px;
}

.viewTicket_formbtndelete__KUInI {
  background-color: #f94747 !important;
}

.viewTicket_edit_b_sc__l0gkN img {
  top: -1px;
  left: 20px;
  width: 18px;
  height: 22px;
  position: absolute;
}

.viewTicket_dlt_btn__M1CT6 {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
}
@media only screen and (max-width: 576px) {
  .viewTicket_dlt_btn__M1CT6 {
    justify-content: start;
  }
}

.viewTicket_attent_details__d4Hri .viewTicket_attent_details_inner__44lF\\+ {
  padding: 0px;
  border-radius: 0px;
  background: #fff;
  box-shadow: none;
  align-items: flex-start;
}

.viewTicket_attent_details_inner_l__-REFj {
  border: solid 1px #ebebeb;
  border-radius: 6px;
  overflow: hidden;
}
@media only screen and (max-width: 767px) {
  .viewTicket_attent_details_inner_l__-REFj {
    border: none;
    border-radius: 0px;
  }
}

.viewTicket_attent_details_contain__jY4CV {
  padding: 20px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
}

.viewTicket_bookedForSomeone__qe8uy {
  font-size: 18px;
  color: #727272;
  font-weight: 600;
  padding-bottom: 10px;
  padding-top: 10px;
}

.viewTicket_participants_contain__dUNba {
  border-radius: 6px;
  border: solid 1px #e2dfdf;
  padding: 24px 24px 30px 24px;
  margin-top: 20px;
}
.viewTicket_participants_contain__dUNba h1 {
  font-size: 20px;
  font-weight: 700;
  color: #0b0d0f;
  margin-bottom: 30px;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl {
  display: flex;
  gap: 20px;
}
@media only screen and (max-width: 768px) {
  .viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl {
    width: 100%;
    flex-wrap: wrap;
  }
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4 {
  width: 16.6%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4 p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4 h5 {
  color: #131f43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_name__emJi3 {
  width: 23%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_email__JGsQ7 {
  width: 30%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_mobile__lPXV6 {
  width: 23%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_age__2OiAL {
  width: 10%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_gender__KVaBD {
  width: 10%;
}
.viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4.viewTicket_participants_amount__p3Fnj {
  width: 10%;
}
@media only screen and (max-width: 768px) {
  .viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4 {
    width: 48% !important;
  }
}
@media only screen and (max-width: 767px) {
  .viewTicket_participants_contain__dUNba .viewTicket_participants_row__gvssl .viewTicket_participants_row_box__JqmS4 {
    width: 100% !important;
  }
}
.viewTicket_participants_contain__dUNba .viewTicket_additional_participant__JlK44 {
  border-top: solid 1px #ccd4f2;
  margin-top: 30px;
  padding-top: 30px;
}
.viewTicket_participants_contain__dUNba .viewTicket_additional_participant__JlK44 h1 {
  margin-bottom: 24px;
}
.viewTicket_participants_contain__dUNba .viewTicket_additional_participant__JlK44 .viewTicket_additional_participant_inner__gKqsm {
  background-color: #f5f6fa;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 10px;
}
.viewTicket_participants_contain__dUNba .viewTicket_additional_participant__JlK44 .viewTicket_additional_participant_inner__gKqsm:last-child {
  margin-bottom: 0px;
}

/* Ticket approval confirm (free registration pending) */
.viewTicket_vticketConfirmOverlay__gb3X7 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.viewTicket_vticketConfirmCard__Gov0H {
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 24px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.viewTicket_vticketConfirmIcon__-41W6 {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.viewTicket_vticketConfirmIconApprove__Z6nVI {
  background: #dcfce7;
}

.viewTicket_vticketConfirmIconReject__MARED {
  background: #fee2e2;
}

.viewTicket_vticketConfirmTitle__5T7df {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  text-align: center;
}

.viewTicket_vticketConfirmBody__gr0bm {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  text-align: center;
  margin: 0;
}
.viewTicket_vticketConfirmBody__gr0bm strong {
  color: #111827;
}

.viewTicket_vticketWaitlistNote__UKA9U {
  font-size: 14px;
  color: #5b21b6;
  line-height: 1.55;
  text-align: center;
  margin: 0 0 10px;
  padding: 12px 14px;
  background: #f5f3ff;
  border-radius: 10px;
  border: 1px solid #ddd6fe;
  width: 100%;
  box-sizing: border-box;
}
.viewTicket_vticketWaitlistNote__UKA9U strong {
  color: #4c1d95;
}

.viewTicket_vticketConfirmActions__g6rrX {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  width: 100%;
  justify-content: center;
}

.viewTicket_vticketConfirmCancelBtn__g-d9p {
  flex: 1 1;
  padding: 10px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.viewTicket_vticketConfirmCancelBtn__g-d9p:hover {
  background: #f9fafb;
}

.viewTicket_vticketConfirmApproveBtn__aZ6UE {
  flex: 1 1;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #16a34a;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.viewTicket_vticketConfirmApproveBtn__aZ6UE:hover {
  background: #15803d;
}

.viewTicket_vticketConfirmRejectBtn__W2RaX {
  flex: 1 1;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.viewTicket_vticketConfirmRejectBtn__W2RaX:hover {
  background: #b91c1c;
}

.viewTicket_quickActionApprove__nAr5u {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  background: #16a34a;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  margin-bottom: 10px;
  transition: background 0.15s ease;
}
.viewTicket_quickActionApprove__nAr5u:hover:not(:disabled) {
  background: #15803d;
}
.viewTicket_quickActionApprove__nAr5u:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.viewTicket_quickActionReject__i3AXr {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border-radius: 8px;
  border: 1.5px solid #fecaca;
  background: #fff5f5;
  color: #991b1b;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  justify-content: center;
  margin-bottom: 10px;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.viewTicket_quickActionReject__i3AXr:hover:not(:disabled) {
  background: #fecaca;
  border-color: #fca5a5;
}
.viewTicket_quickActionReject__i3AXr:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media only screen and (max-width: 992px) {
  .viewTicket_profilepicdiv__shdys {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 600px) {
  #viewTicket_dashboardcont2__piBf7 {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
  .viewTicket_dlt_btn__M1CT6 {
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/shows/viewTicket.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ADvEH;;AC0EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADvEH;;AC0EC;;;EAGE,yBAnEoB;ADJvB;;AC0EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADvEH;;AC0EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ADrEH;;AC2EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADxEH;;AC6EC;EACE,2BAAA;AD1EH;;AC6EC;EACE,yBAAA;EACA,YAAA;AD1EH;;AC8EC;EACE,YAAA;AD3EH;;AC8EC;EACE,sBA9GY;ADmCf;;AC8EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD3EH;;AC8EC;EACE,yBArIgB;EAsIhB,iBAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAlIY;ADuDf;;AC8EC;EACE,yBAjJgB;ADsEnB;;AC8EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD3EH;;AC8EC;;CAAA;AAGA;EACE,sBAvJY;AD4Ef;;AC8EC;EACE,yBAtKgB;AD2FnB;;AC8EC;;CAAA;AAGA;EACE,yBAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;;EAEE,sBAAA;AD3EH;;AC8EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ADwHrB;;AC8EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,sBAAA;EACA,oCAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;EACE,0BAAA;AD3EH;;AC8EC;EACE,uBAAA;AD3EH;;AC8EC;;EAEE,qBAAA;AD3EH;;AC8EC;EACE,yBAjOsB;EAkOtB,WAzNY;AD8If;;AC8EC;;CAAA;AAGA;EACE,cA7Ne;ADkJlB;;AC8EC;EACE,cAjOe;ADsJlB;;AC8EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AD3EH;;AC8EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AD3EH;;AC8EC;EACE,cAnPe;ADwKlB;;AC8EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AD3EH;;AC8EC;EACE,WAlQY;ADuLf;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;;EAEE,0BAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,kBAAA;AD3EH;;AC8EC;EACE,oCAAA;EACA,gCAAA;AD3EH;;AC8EC;EACE,yBArRkB;EAsRlB,WA9RY;ADmNf;;AC8EC;EACE,yBAAA;AD3EH;;AC8EC;EACE,iBAAA;AD3EH;;AC8EC;;EAEE,+BAAA;EACA,iBAAA;AD3EH;;AC8EC;EACE,sBAhTY;ADqOf;AC6EG;EACE,sBAnTU;EAoTV,YAAA;AD3EL;;AC+EC;EACE,0CAAA;EACA,cAvTe;AD2OlB;AC8EG;EACE,yCAAA;EACA,eAAA;AD5EL;;ACgFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;EACE,yBAAA;EACA,0BAAA;AD7EH;;ACgFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AD7EH;;ACgFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AD7EH;AC+EG;EACE,cA3Va;AD8QlB;;ACkFC;;CAAA;AAGA;EACE,yBA1WgB;AD2RnB;;ACkFC;EACE,yBAAA;EACA,yBAAA;AD/EH;;ACkFC;EACE,yBA1XoB;EA2XpB,yBAAA;AD/EH;;ACkFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EH;;ACkFC;;CAAA;AAGA;EACE,sBA9XY;AD+Sf;;ACkFC;EACE,yBA1XkB;AD2SrB;;ACmFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AD2Tf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBApZY;ADoUf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBA7ZY;AD6Uf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;EACE,gGAAA;EACA,sBAtaY;ADsVf;;ACmFC;EACE,mBAAA;ADhFH;;ACmFC;;;;;;;;EAQE,WArbY;ADqWf;;ACmFC;;CAAA;AAGA;EACE,qCAAA;ADhFH;;ACmFC;EACE,cA7be;AD6WlB;;ACoFC;;CAAA;AAGA;EACE,sBAAA;ADjFH;;ACoFC;EACE,yBAAA;ADjFH;;ACoFC;EACE,yBAjekB;EAkelB,WAjdY;ADgYf;;ACoFC;EACE,yBAtekB;EAuelB,WAtdY;ADqYf;;ACoFC;EACE,6BAAA;ADjFH;;ACoFC;EACE,2BAAA;ADjFH;;ACoFC;EACE,yBAnfkB;ADkarB;;ACoFC;EACE,yBAtfwB;ADqa3B;;ACoFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;ADjFH;;ACqFC;EACE,yBA5fgB;AD0anB;;ACqFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFH;;ACqFC;;;EAGE,oCAAA;EACA,sBAAA;ADlFH;;ACqFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AD8ejB;;ACqFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ADwfjB;;ACqFC;EACE,yBAtjBY;ADoef;;ACqFC;EACE,yBA/iBkB;AD6drB;;ACqFC;EACE,yBAljBwB;ADge3B;;ACqFC;EACE,cAxjBiB;ADsepB;;ACsFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFH;;ACsFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ADnFH;;ACsFC;EACE,QAAA;ADnFH;;ACuFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ADpFH;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFH;;ACuFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ADpFH;;ACuFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ADpFF;;ACuFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADpFH;;ACuFC;;;EAGE,oCAAA;ADpFH;;ACuFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ADpFF;;ACyFC;EACE,aAAA;EACA,kBAAA;ADtFH;;ACyFC;EACE,mBAAA;ADtFH;;ACyFC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADtFH;;ACyFC;EACE,UAAA;ADtFH;;ACyFC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AD4kBrB;;ACyFC;EACE,aAtqBkB;ADglBrB;;ACyFC;EACE,yBAlqBgB;AD4kBnB;;ACyFC;EACE,yBAAA;ADtFH;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AD2kBf;;ACyFC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ADilBf;;ACyFC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ADulBf;;ACyFC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AD4lBf;;ACyFC;;;EAGE,WAxrBY;ADkmBf;;ACyFC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ADwmBf;;ACyFC;EACE,yBAjvBO;AD2pBV;;ACyFC;EACE,eAjtBgB;AD2nBnB;;ACyFC;EACE,YA1sBY;ADonBf;;ACyFC;;EAEE,sBAAA;ADtFH;;ACyFC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AD1FH;;AC6FC;EACE,0BAAA;AD1FH;;AC6FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AD1FH;;AC6FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AD1FH;;AC6FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AD1FH;;AC6FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AD1FH;;AC6FC;;EAEE,0BAAA;EACA,aAAA;AD1FH;;AC6FC;EACE,kBAAA;AD1FH;;AC6FC;EACE;IACE,gBAAA;ED1FH;AACF;AC6FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;ED3FH;EC8FC;IACE,2BAAA;IACA,gBAAA;ED5FH;AACF;AC+FC;EACE;;IAAA;EAGA;;IAAA;AD3FH;ACgGC;EACE;IACE,uBAAA;ED9FH;ECgGD;IACE,0BAAA;IACA,2BAAA;ED9FD;ECgGC;IACE,6BAAA;ED9FH;AACF;ACiGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FH;ECkGC;;IAEE,kBAAA;EDhGH;ECmGC;IACE,eAAA;EDjGH;ECoGC;IACE,aAAA;EDlGH;ECqGC;IACE,8BAAA;IACA,aAAA;EDnGH;AACF;ACsGC;EACE;IACE,iBAAA;EDpGH;ECuGC;IACE,gBAAA;EDrGH;ECwGC;;IAAA;ADpGH;ACyGC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGH;AC4GG;EACE,WAAA;EACA,cAAA;AD1GL;AC4GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AD1GP;AC2GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDxGP;AACF;ACyGO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADvGT;AC2GK;EACE,WAAA;EACA,cAAA;ADzGP;AC0GC;EACC,cAAA;ADxGF;AC0GO;EACE,WAAA;EACA,mBAAA;ADxGT;AC0GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADxGX;AC2GS;EACE,kFAAA;ADzGX;AC8GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD5GT;AC+GO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD7GT;AC+GS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD7GX;;ACoHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADlHL;ACoHK;EATF;IAUI,yBAAA;EDjHL;AACF;ACmHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EDhHL;AACF;ACmHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;ADjHT;ACkHS;EALF;IAMG,mBAAA;IACA,WAAA;ED/GR;AACF;ACmHK;EACE,SAAA;ADjHP;ACmHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHT;ACmHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHT;AACF;ACkHS;EACE,SAAA;EACA,UAAA;ADhHX;ACkHW;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GX;AACF;ACiHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GX;AACF;ACgHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9Gb;ACiHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/Gb;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACuHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ADpHH;ACqHG;EANF;IAOI,0BAAA;EDlHH;AACF;;ACoHC;EACE,gBAAA;EACA,WAAA;ADjHH;ACmHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;ADjHL;ACmHK;EATF;IAUI,iBAAA;EDhHL;AACF;ACkHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ADhHP;ACmHK;EACE,cAAA;ADjHP;ACoHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ADlHP;ACqHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ADnHP;ACqHO;EANF;IAOI,4BAAA;EDlHP;AACF;ACqHK;EACE,eAAA;ADnHP;ACuHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADrHL;ACuHK;EALF;IAMI,uBAAA;EDpHL;AACF;ACsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADpHP;ACsHO;EALF;IAMI,4BAAA;EDnHP;AACF;ACqHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ADnHP;ACoHO;EARF;IASI,eAAA;EDjHP;AACF;;ACwHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADrHH;ACuHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADrHL;;AAjlCA,sEAAA;AAEA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AAmlCF;;AAhlCA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAmlCF;;AAhlCA;;EAEE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AAmlCF;;AAhlCA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;AAmlCF;;AAhlCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AAmlCF;;AAhlCA;EACE,iBAAA;EACA,cAAA;AAmlCF;;AAhlCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAmlCF;;AAhlCA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;AAmlCF;;AAhlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAmlCF;;AAhlCA,WAAA;AACA;EACE;IACE,gCAAA;IACA,SAAA;EAmlCF;AACF;AAhlCA,gCAAA;AACA;EACE;IACE,UAAA;IACA,kBAAA;IACA,eAAA;EAklCF;EA/kCA;IACE,qCAAA;IACA,MAAA;IACA,gBAAA;EAilCF;EA9kCA;IACE,QAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;EAglCF;EA7kCA;IACE,QAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;EA+kCF;EA5kCA;IACE,8BAAA;IACA,cAAA;EA8kCF;EA3kCA;IACE,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,iBAAA;IACA,QAAA;EA6kCF;EA1kCA;IACE,cAAA;IACA,YAAA;EA4kCF;EAzkCA;IACE,iBAAA;IACA,cAAA;EA2kCF;EAxkCA;IACE,eAAA;EA0kCF;AACF;AAvkCA,WAAA;AACA;EACE;IACE,0BAAA;IACA,MAAA;EAykCF;EAtkCA;IACE,eAAA;EAwkCF;AACF;AArkCA,iBAAA;AACA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,eAAA;EAukCF;EApkCA;IACE,gBAAA;IACA,WAAA;EAskCF;EAnkCA;IACE,eAAA;EAqkCF;AACF;AAlkCA,gCAAA;AAEA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmkCF;AAjkCE;EACE,eAAA;EAEA,iBAAA;AAkkCJ;AA/jCE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAikCJ;AA9jCE;EACE,WAAA;EACA,kBAAA;AAgkCJ;AA9jCE;EACE,qBAAA;AAgkCJ;AA7jCE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA+jCJ;AA7jCE;EACE,eAAA;EAEA,iBAAA;AA8jCJ;AA3jCE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA6jCJ;AA3jCI;EACE,eAAA;AA6jCN;AA1jCI;EACE,eAAA;EACA,cCzNW;ED0NX,gBChOW;EDiOX,kBAAA;EAEA,uBAAA;EACA,gBAAA;AA2jCN;AAvjCE;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAyjCJ;AAvjCI;EACE,yBAAA;EACA,WAAA;AAyjCN;;AApjCA;EACE,aAAA;AAujCF;AAtjCE;EAFF;IAGI,aAAA;EAyjCF;AACF;;AAtjCA;EACE,eAAA;EACA,kBAAA;AAyjCF;;AAtjCA;EACE,WChNa;ADywCf;;AAvjCA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;AA0jCF;;AAxjCA;EACE,oCAAA;AA2jCF;;AAxjCA;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA2jCF;;AAxjCA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AA2jCF;AA1jCE;EAJF;IAKI,sBAAA;EA6jCF;AACF;;AA1jCA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA6jCF;;AA1jCA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AA6jCF;AA5jCE;EAJF;IAKI,YAAA;IACA,kBAAA;EA+jCF;AACF;;AA5jCA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AA+jCF;;AA5jCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AA+jCF;;AA5jCA;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;AA+jCF;AA9jCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAgkCJ;AA9jCE;EACE,aAAA;EACA,SAAA;AAgkCJ;AA/jCI;EAHF;IAII,WAAA;IACA,eAAA;EAkkCJ;AACF;AAjkCI;EACE,YAAA;AAmkCN;AAlkCM;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAokCR;AAlkCM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EACE,UAAA;AAokCR;AAlkCM;EApCF;IAqCI,qBAAA;EAqkCN;AACF;AApkCM;EAvCF;IAwCI,sBAAA;EAukCN;AACF;AApkCE;EACE,6BAAA;EACA,gBAAA;EACA,iBAAA;AAskCJ;AArkCI;EACE,mBAAA;AAukCN;AArkCI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAukCN;AAtkCM;EACE,kBAAA;AAwkCR;;AAlkCA,wDAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAqkCF;;AAlkCA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAqkCF;;AAlkCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAqkCF;;AAlkCA;EACE,mBAAA;AAqkCF;;AAlkCA;EACE,mBAAA;AAqkCF;;AAlkCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAqkCF;;AAlkCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAqkCF;AAnkCE;EACE,cAAA;AAqkCJ;;AAjkCA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAokCF;AAlkCE;EACE,cAAA;AAokCJ;;AAhkCA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AAmkCF;;AAhkCA;EACE,SAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAmkCF;AAjkCE;EACE,mBAAA;AAmkCJ;;AA/jCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAkkCF;AAhkCE;EACE,mBAAA;AAkkCJ;;AA9jCA;EACE,SAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAikCF;AA/jCE;EACE,mBAAA;AAikCJ;;AA7jCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AAgkCF;AA9jCE;EACE,mBAAA;AAgkCJ;AA7jCE;EACE,aAAA;EACA,mBAAA;AA+jCJ;;AA3jCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,0DAAA;AA8jCF;AA5jCE;EACE,mBAAA;EACA,qBAAA;AA8jCJ;AA3jCE;EACE,aAAA;EACA,mBAAA;AA6jCJ;;AAzjCA;EACE;IACE,mBAAA;EA4jCF;AACF;AAzjCA;EACE;IACE,wBC3gBS;ID4gBT,UC3gBQ;ID4gBR,kBAAA;IACA,aCnhBgB;ED8kDlB;EAzjCA;IACE,SAAA;EA2jCF;AACF","sourcesContent":["@import '../../styles/Variables/Variables.scss';\n\n/* ── Ticket Details Page Layout ─────────────────────────────────── */\n\n.pageWrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  padding: 0 4px;\n}\n\n.pageLayout {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 20px;\n  align-items: start;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.mainPanel,\n.sidebarPanel {\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.statusCard {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  padding: 24px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.statusLeft {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 0 0 auto;\n}\n\n.statusRight {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.priceAmount {\n  font-size: 26px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 32px;\n}\n\n.loadingWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  width: 100%;\n}\n\n/* Tablet */\n@media only screen and (max-width: 1024px) {\n  .pageLayout {\n    grid-template-columns: 1fr 240px;\n    gap: 16px;\n  }\n}\n\n/* Small tablet / large mobile */\n@media only screen and (max-width: 768px) {\n  .pageWrapper {\n    padding: 0;\n    overflow-x: hidden;\n    max-width: 100%;\n  }\n\n  .pageLayout {\n    grid-template-columns: 1fr !important;\n    gap: 0;\n    overflow: hidden;\n  }\n\n  .mainPanel {\n    order: 1;\n    min-width: 0;\n    max-width: 100%;\n    overflow: hidden;\n  }\n\n  .sidebarPanel {\n    order: 2;\n    min-width: 0;\n    max-width: 100%;\n    margin-top: 16px;\n    overflow: hidden;\n  }\n\n  .infoGrid {\n    grid-template-columns: 1fr 1fr;\n    gap: 10px 20px;\n  }\n\n  .statusCard {\n    padding: 14px 16px;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: 8px;\n  }\n\n  .statusLeft {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .statusRight {\n    text-align: right;\n    flex: 0 0 auto;\n  }\n\n  .priceAmount {\n    font-size: 20px;\n  }\n}\n\n/* Mobile */\n@media only screen and (max-width: 576px) {\n  .infoGrid {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  .priceAmount {\n    font-size: 18px;\n  }\n}\n\n/* Small mobile */\n@media only screen and (max-width: 400px) {\n  .statusCard {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .statusRight {\n    text-align: left;\n    width: 100%;\n  }\n\n  .priceAmount {\n    font-size: 22px;\n  }\n}\n\n/* ── existing styles below ── */\n\n#addform {\n  width: 100%;\n  border-radius: 5px;\n  margin-top: 30px;\n  margin-bottom: 20px;\n\n  #addheading {\n    font-size: 18px;\n\n    margin-left: 10px;\n  }\n\n  .profilepicdiv {\n    padding: 0px;\n    border-radius: 5px;\n    text-align: center;\n  }\n\n  .profilepic {\n    width: 100%;\n    border-radius: 5px;\n  }\n  .namesection {\n    display: inline-block;\n  }\n\n  .profilename {\n    font-size: 16px;\n    margin-left: 20px;\n    margin-top: 30px;\n  }\n  .profileemail {\n    font-size: 14px;\n\n    margin-left: 20px;\n  }\n\n  #empdiv {\n    padding: 0px;\n    margin-bottom: 20px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    background-color: transparent;\n\n    .title {\n      font-size: 13px;\n    }\n\n    .empname {\n      font-size: 16px;\n      color: $primary-color;\n      font-weight: $font-semiBold;\n      margin-bottom: 0px;\n      // padding-bottom:8px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n    }\n  }\n\n  .arrowback {\n    float: right;\n    background-color: #dde2eb;\n    padding: 10px;\n    color: #39979d;\n    cursor: pointer;\n    border-radius: 3px;\n\n    &:hover {\n      background-color: #39979d;\n      color: #fff;\n    }\n  }\n}\n\n.profile_view_container {\n  padding: 30px;\n  @media screen and (max-width: 768px) {\n    padding: 15px;\n  }\n}\n\n.profile_view_container span {\n  font-size: 13px;\n  margin-bottom: 7px;\n}\n\n.formthemedark.profile_view_container span {\n  color: $white-color;\n}\n.edit_b_sc .formbtnedit {\n  padding: 0 17px 0 28px !important;\n  background-color: #ff9330 !important;\n  min-width: 110px;\n}\n.formbtndelete {\n  background-color: #f94747 !important;\n}\n\n.edit_b_sc img {\n  top: -1px;\n  left: 20px;\n  width: 18px;\n  height: 22px;\n  position: absolute;\n}\n\n.dlt_btn {\n  display: flex;\n  justify-content: flex-end;\n  gap: 30px;\n  @media only screen and (max-width: 576px) {\n    justify-content: start;\n  }\n}\n\n.attent_details .attent_details_inner {\n  padding: 0px;\n  border-radius: 0px;\n  background: #fff;\n  box-shadow: none;\n  align-items: flex-start;\n}\n\n.attent_details_inner_l {\n  border: solid 1px #ebebeb;\n  border-radius: 6px;\n  overflow: hidden;\n  @media only screen and (max-width: 767px) {\n    border: none;\n    border-radius: 0px;\n  }\n}\n\n.attent_details_contain {\n  padding: 20px;\n  border-radius: 5px;\n  background: #fff;\n  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n}\n\n.bookedForSomeone {\n  font-size: 18px;\n  color: #727272;\n  font-weight: 600;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.participants_contain {\n  border-radius: 6px;\n  border: solid 1px #e2dfdf;\n  padding: 24px 24px 30px 24px;\n  margin-top: 20px;\n  h1 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #0b0d0f;\n    margin-bottom: 30px;\n  }\n  .participants_row {\n    display: flex;\n    gap: 20px;\n    @media only screen and (max-width: 768px) {\n      width: 100%;\n      flex-wrap: wrap;\n    }\n    .participants_row_box {\n      width: 16.6%;\n      p {\n        margin-bottom: 10px;\n        color: #727272;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n      }\n      h5 {\n        color: #131f43;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        word-wrap: break-word;\n      }\n      &.participants_name {\n        width: 23%;\n      }\n      &.participants_email {\n        width: 30%;\n      }\n      &.participants_mobile {\n        width: 23%;\n      }\n      &.participants_age {\n        width: 10%;\n      }\n      &.participants_gender {\n        width: 10%;\n      }\n      &.participants_amount {\n        width: 10%;\n      }\n      @media only screen and (max-width: 768px) {\n        width: 48% !important;\n      }\n      @media only screen and (max-width: 767px) {\n        width: 100% !important;\n      }\n    }\n  }\n  .additional_participant {\n    border-top: solid 1px #ccd4f2;\n    margin-top: 30px;\n    padding-top: 30px;\n    h1 {\n      margin-bottom: 24px;\n    }\n    .additional_participant_inner {\n      background-color: #f5f6fa;\n      border-radius: 6px;\n      padding: 20px;\n      margin-bottom: 10px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n/* Ticket approval confirm (free registration pending) */\n.vticketConfirmOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.vticketConfirmCard {\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px 28px 24px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.vticketConfirmIcon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.vticketConfirmIconApprove {\n  background: #dcfce7;\n}\n\n.vticketConfirmIconReject {\n  background: #fee2e2;\n}\n\n.vticketConfirmTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  text-align: center;\n}\n\n.vticketConfirmBody {\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.6;\n  text-align: center;\n  margin: 0;\n\n  strong {\n    color: #111827;\n  }\n}\n\n.vticketWaitlistNote {\n  font-size: 14px;\n  color: #5b21b6;\n  line-height: 1.55;\n  text-align: center;\n  margin: 0 0 10px;\n  padding: 12px 14px;\n  background: #f5f3ff;\n  border-radius: 10px;\n  border: 1px solid #ddd6fe;\n  width: 100%;\n  box-sizing: border-box;\n\n  strong {\n    color: #4c1d95;\n  }\n}\n\n.vticketConfirmActions {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n  width: 100%;\n  justify-content: center;\n}\n\n.vticketConfirmCancelBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #f9fafb;\n  }\n}\n\n.vticketConfirmApproveBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #16a34a;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #15803d;\n  }\n}\n\n.vticketConfirmRejectBtn {\n  flex: 1;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: #b91c1c;\n  }\n}\n\n.quickActionApprove {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: none;\n  background: #16a34a;\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  width: 100%;\n  justify-content: center;\n  margin-bottom: 10px;\n  transition: background 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: #15803d;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.quickActionReject {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: 1.5px solid #fecaca;\n  background: #fff5f5;\n  color: #991b1b;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  width: 100%;\n  justify-content: center;\n  margin-bottom: 10px;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: #fecaca;\n    border-color: #fca5a5;\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .profilepicdiv {\n    margin-bottom: 30px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  #dashboardcont2 {\n    width: $dashwidth;\n    left: $dashleft;\n    position: relative;\n    padding: $dashboardpadding;\n  }\n  .dlt_btn {\n    gap: 20px;\n  }\n}\n","/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewTicket_dashboard__aNZYx`,
	"dashboardContain": `viewTicket_dashboardContain__yW1oK`,
	"bodythemedark": `viewTicket_bodythemedark__wCIg-`,
	"cont2": `viewTicket_cont2__2Jbki`,
	"top_header": `viewTicket_top_header__ws95f`,
	"top_header_inner": `viewTicket_top_header_inner__YMlQN`,
	"subLink": `viewTicket_subLink__RT-x4`,
	"cst_vendr": `viewTicket_cst_vendr__JnvXV`,
	"form-control": `viewTicket_form-control__LEtJC`,
	"footer": `viewTicket_footer__++L1x`,
	"bodythemelight": `viewTicket_bodythemelight__od1Pk`,
	"headerthemelight": `viewTicket_headerthemelight__SAQLg`,
	"headerthemedark": `viewTicket_headerthemedark__H6h5V`,
	"menuthemelight": `viewTicket_menuthemelight__X7JCP`,
	"menuthemedark": `viewTicket_menuthemedark__V+GGf`,
	"menulinklight": `viewTicket_menulinklight__yd0cJ`,
	"menulinkdarkSelected": `viewTicket_menulinkdarkSelected__eSADz`,
	"menulinklightSelected": `viewTicket_menulinklightSelected__4VQa6`,
	"menulinkdark": `viewTicket_menulinkdark__+LNZg`,
	"sub_arrow": `viewTicket_sub_arrow__8GScY`,
	"headinglight": `viewTicket_headinglight__34zIa`,
	"headingdark": `viewTicket_headingdark__AZLsQ`,
	"searchboxlight": `viewTicket_searchboxlight__ecjOU`,
	"searchboxdark": `viewTicket_searchboxdark__ah1oz`,
	"tableheadlight": `viewTicket_tableheadlight__CCjgR`,
	"tableheaddark": `viewTicket_tableheaddark__HGPum`,
	"table": `viewTicket_table__5QzYT`,
	"table-borderless": `viewTicket_table-borderless__UwRrM`,
	"left-section": `viewTicket_left-section__IGUPk`,
	"tablebodylight": `viewTicket_tablebodylight__51UYI`,
	"tablebodydark": `viewTicket_tablebodydark__-YlqC`,
	"paginationlight": `viewTicket_paginationlight__HPZqd`,
	"paginationdark": `viewTicket_paginationdark__OwMcr`,
	"formthemelight": `viewTicket_formthemelight__wG-Rw`,
	"formthemedark": `viewTicket_formthemedark__gj5iY`,
	"viewformlight": `viewTicket_viewformlight__Ho4P4`,
	"permissionboxlight": `viewTicket_permissionboxlight__z6w1h`,
	"permissionboxdark": `viewTicket_permissionboxdark__SxYZd`,
	"errormsgclr": `viewTicket_errormsgclr__XW8zC`,
	"graphclrlight": `viewTicket_graphclrlight__uYIfz`,
	"graphclrdark": `viewTicket_graphclrdark__yxJ-S`,
	"card1bglight": `viewTicket_card1bglight__BO-A3`,
	"card1bgdark": `viewTicket_card1bgdark__1dqP3`,
	"card2bglight": `viewTicket_card2bglight__eGKtx`,
	"card2bgdark": `viewTicket_card2bgdark__EPPlH`,
	"card3bglight": `viewTicket_card3bglight__EOZDZ`,
	"card3bgdark": `viewTicket_card3bgdark__Ja6gy`,
	"card4bglight": `viewTicket_card4bglight__QYRg6`,
	"card4bgdark": `viewTicket_card4bgdark__PSkAj`,
	"actionbtnlight": `viewTicket_actionbtnlight__P9Hky`,
	"actionbtndark": `viewTicket_actionbtndark__--6OQ`,
	"profiledropdownlight": `viewTicket_profiledropdownlight__NH-Fu`,
	"profiledropdowndark": `viewTicket_profiledropdowndark__YGP00`,
	"settingsection": `viewTicket_settingsection__Gzgmn`,
	"addform": `viewTicket_addform__7eDjY`,
	"savebtn": `viewTicket_savebtn__Ypy0O`,
	"profile_conatiner": `viewTicket_profile_conatiner__3WtDM`,
	"ag-theme-alpine": `viewTicket_ag-theme-alpine__dIuO3`,
	"ag-row": `viewTicket_ag-row__kEuDw`,
	"formbtn": `viewTicket_formbtn__MSRUq`,
	"resetbtn": `viewTicket_resetbtn__kNbK7`,
	"addBtn": `viewTicket_addBtn__ToIWh`,
	"addDltBtn": `viewTicket_addDltBtn__zG4Nu`,
	"addbtnlight": `viewTicket_addbtnlight__YwzpA`,
	"addbtndark": `viewTicket_addbtndark__gU6YW`,
	"cust_addBtn": `viewTicket_cust_addBtn__j8iRX`,
	"deleteBtn": `viewTicket_deleteBtn__YvlSa`,
	"confirmBtn": `viewTicket_confirmBtn__DbuOk`,
	"delPopContainer": `viewTicket_delPopContainer__4uHNt`,
	"modal-body": `viewTicket_modal-body__SfY4l`,
	"delet_icon": `viewTicket_delet_icon__ghEWv`,
	"arrowback": `viewTicket_arrowback__NJet5`,
	"drpdwn_btn": `viewTicket_drpdwn_btn__g-Uz1`,
	"empname": `viewTicket_empname__tlX3M`,
	"navitemli": `viewTicket_navitemli__EHaWT`,
	"tabnavli": `viewTicket_tabnavli__Or8x4`,
	"settingsgeneral": `viewTicket_settingsgeneral__XLmfK`,
	"settingslinks": `viewTicket_settingslinks__m6xFw`,
	"dropdown_menu_contain": `viewTicket_dropdown_menu_contain__g3iQ1`,
	"dropdown_item": `viewTicket_dropdown_item__Lv-Nx`,
	"profile_arrrow_dwn": `viewTicket_profile_arrrow_dwn__vFacI`,
	"dateinputbox1": `viewTicket_dateinputbox1__SuLx-`,
	"modal-content": `viewTicket_modal-content__uINlq`,
	"larg_model": `viewTicket_larg_model__hCwH7`,
	"modal-dialog": `viewTicket_modal-dialog__oRQIJ`,
	"modal-header": `viewTicket_modal-header__EGbzH`,
	"btn-primary": `viewTicket_btn-primary__5Mfef`,
	"form-select": `viewTicket_form-select__5SA+y`,
	"CustomTable_tableheadlight__HuHZw": `viewTicket_CustomTable_tableheadlight__HuHZw__AZF+-`,
	"CustomTable_tableheaddark__nwqb4": `viewTicket_CustomTable_tableheaddark__nwqb4__Bab9Q`,
	"sectionright": `viewTicket_sectionright__De7mJ`,
	"exer_modal_contain": `viewTicket_exer_modal_contain__d9rqY`,
	"active_show_outer": `viewTicket_active_show_outer__Oi6fk`,
	"active_show_inner": `viewTicket_active_show_inner__q5Wv2`,
	"act_box_img": `viewTicket_act_box_img__BFoa7`,
	"act_box_cnt": `viewTicket_act_box_cnt__uZAS8`,
	"act_box_bdg": `viewTicket_act_box_bdg__wJGic`,
	"sold": `viewTicket_sold__Fnz7n`,
	"attent_details": `viewTicket_attent_details__d4Hri`,
	"attent_details_inner": `viewTicket_attent_details_inner__44lF+`,
	"attent_details_inner_l": `viewTicket_attent_details_inner_l__-REFj`,
	"attent_details_inner_r": `viewTicket_attent_details_inner_r__sZWfz`,
	"attent_details_row": `viewTicket_attent_details_row__jsCrT`,
	"attent_details_row_box": `viewTicket_attent_details_row_box__Iu6-l`,
	"attent_details_row_last": `viewTicket_attent_details_row_last__krk96`,
	"interesting_fact": `viewTicket_interesting_fact__VbzRg`,
	"showbox_sec": `viewTicket_showbox_sec__5nRCW`,
	"show_box_main": `viewTicket_show_box_main__jd51W`,
	"show_box": `viewTicket_show_box__nQUUK`,
	"no_show_box": `viewTicket_no_show_box__jfQOg`,
	"attent_flex": `viewTicket_attent_flex__p0fTT`,
	"pageWrapper": `viewTicket_pageWrapper__0y7NX`,
	"pageLayout": `viewTicket_pageLayout__S7+IY`,
	"mainPanel": `viewTicket_mainPanel__3IR3K`,
	"sidebarPanel": `viewTicket_sidebarPanel__ReZbf`,
	"statusCard": `viewTicket_statusCard__WRzmJ`,
	"statusLeft": `viewTicket_statusLeft__3n-ES`,
	"statusRight": `viewTicket_statusRight__q9Iwu`,
	"priceAmount": `viewTicket_priceAmount__TA+Ha`,
	"infoGrid": `viewTicket_infoGrid__6u5M2`,
	"loadingWrap": `viewTicket_loadingWrap__B79vS`,
	"addheading": `viewTicket_addheading__j8PRp`,
	"profilepicdiv": `viewTicket_profilepicdiv__shdys`,
	"profilepic": `viewTicket_profilepic__0JGHL`,
	"namesection": `viewTicket_namesection__-msR3`,
	"profilename": `viewTicket_profilename__XymQp`,
	"profileemail": `viewTicket_profileemail__QjRnA`,
	"empdiv": `viewTicket_empdiv__pCYvk`,
	"title": `viewTicket_title__fHmC9`,
	"profile_view_container": `viewTicket_profile_view_container__Fqdno`,
	"edit_b_sc": `viewTicket_edit_b_sc__l0gkN`,
	"formbtnedit": `viewTicket_formbtnedit__PSiYh`,
	"formbtndelete": `viewTicket_formbtndelete__KUInI`,
	"dlt_btn": `viewTicket_dlt_btn__M1CT6`,
	"attent_details_contain": `viewTicket_attent_details_contain__jY4CV`,
	"bookedForSomeone": `viewTicket_bookedForSomeone__qe8uy`,
	"participants_contain": `viewTicket_participants_contain__dUNba`,
	"participants_row": `viewTicket_participants_row__gvssl`,
	"participants_row_box": `viewTicket_participants_row_box__JqmS4`,
	"participants_name": `viewTicket_participants_name__emJi3`,
	"participants_email": `viewTicket_participants_email__JGsQ7`,
	"participants_mobile": `viewTicket_participants_mobile__lPXV6`,
	"participants_age": `viewTicket_participants_age__2OiAL`,
	"participants_gender": `viewTicket_participants_gender__KVaBD`,
	"participants_amount": `viewTicket_participants_amount__p3Fnj`,
	"additional_participant": `viewTicket_additional_participant__JlK44`,
	"additional_participant_inner": `viewTicket_additional_participant_inner__gKqsm`,
	"vticketConfirmOverlay": `viewTicket_vticketConfirmOverlay__gb3X7`,
	"vticketConfirmCard": `viewTicket_vticketConfirmCard__Gov0H`,
	"vticketConfirmIcon": `viewTicket_vticketConfirmIcon__-41W6`,
	"vticketConfirmIconApprove": `viewTicket_vticketConfirmIconApprove__Z6nVI`,
	"vticketConfirmIconReject": `viewTicket_vticketConfirmIconReject__MARED`,
	"vticketConfirmTitle": `viewTicket_vticketConfirmTitle__5T7df`,
	"vticketConfirmBody": `viewTicket_vticketConfirmBody__gr0bm`,
	"vticketWaitlistNote": `viewTicket_vticketWaitlistNote__UKA9U`,
	"vticketConfirmActions": `viewTicket_vticketConfirmActions__g6rrX`,
	"vticketConfirmCancelBtn": `viewTicket_vticketConfirmCancelBtn__g-d9p`,
	"vticketConfirmApproveBtn": `viewTicket_vticketConfirmApproveBtn__aZ6UE`,
	"vticketConfirmRejectBtn": `viewTicket_vticketConfirmRejectBtn__W2RaX`,
	"quickActionApprove": `viewTicket_quickActionApprove__nAr5u`,
	"quickActionReject": `viewTicket_quickActionReject__i3AXr`,
	"dashboardcont2": `viewTicket_dashboardcont2__piBf7`
};
export default ___CSS_LOADER_EXPORT___;
